function createTechnologies({ key, name, icon, softColor = "#eef4ff", accentColor = "#2f63db" }) {
  return {
    key,
    name,
    icon,
    softColor,
    accentColor,
  };
}

export const technologies = [
  createTechnologies({
    key: "game",
    name: "Game",
    icon: "games.png",
    softColor: "#fdf4e7",
    accentColor: "#c9801d",
  }),
  createTechnologies({
    key: "web",
    name: "Web",
    icon: "web.png",
    softColor: "#e9f7ff",
    accentColor: "#1378a8",
  }),
  createTechnologies({
    key: "software",
    name: "Software",
    icon: "software.png",
    softColor: "#eef3ff",
    accentColor: "#4f6fd8",
  }),
  createTechnologies({
    key: "mobile",
    name: "Mobile",
    icon: "mobile.png",
    softColor: "#edf8ef",
    accentColor: "#348f4a",
  }),
  createTechnologies({
    key: "unity",
    name: "Unity",
    icon: "unity.png",
    softColor: "#eef1f7",
    accentColor: "#36415d",
  }),
  createTechnologies({
    key: "csharp",
    name: "C#",
    icon: "csharp.png",
    softColor: "#f0ecff",
    accentColor: "#6b4ecf",
  }),
  createTechnologies({
    key: "bubble",
    name: "Bubble.io",
    icon: "bubble-io.png",
    softColor: "#e9f4ff",
    accentColor: "#2f80ec",
  }),
  createTechnologies({
    key: "photon",
    name: "Photon",
    icon: "photon.png",
    softColor: "#fff2ee",
    accentColor: "#d05b3f",
  }),
  createTechnologies({
    key: "javascript",
    name: "Javascript",
    icon: "javascript.png",
    softColor: "#fff9dc",
    accentColor: "#a07700",
  }),
  createTechnologies({
    key: "react",
    name: "React",
    icon: "react.png",
    softColor: "#e8fbff",
    accentColor: "#1296b9",
  }),
  createTechnologies({
    key: "nodejs",
    name: "Node.js",
    icon: "node-js.png",
    softColor: "#edf8ea",
    accentColor: "#3d8f3a",
  }),
  createTechnologies({
    key: "java",
    name: "Java",
    icon: "java.png",
    softColor: "#fff0ea",
    accentColor: "#bf4f22",
  }),
  createTechnologies({
    key: "spring-boot",
    name: "Spring Boot",
    icon: "spring-boot.svg",
    softColor: "#eefbe9",
    accentColor: "#2f8f3f",
  }),
  createTechnologies({
    key: "postgresql",
    name: "PostgreSQL",
    icon: "postgreesql.png",
    softColor: "#eef3ff",
    accentColor: "#2f5cb5",
  }),
  createTechnologies({
    key: "terraform",
    name: "Terraform",
    icon: "terraform.png",
    softColor: "#f3ecff",
    accentColor: "#6f44d3",
  }),
  createTechnologies({
    key: "next.js",
    name: "Next.js",
    icon: "next-js.webp",
    softColor: "#f0f2f5",
    accentColor: "#3e4c66",
  }),
  createTechnologies({
    key: "IA",
    name: "IA",
    icon: "ia.png",
    softColor: "#ffeef3",
    accentColor: "#cc4b77",
  }),
  createTechnologies({
    key: "n8n",
    name: "n8n",
    icon: "n8n.png",
    softColor: "#fff0ea",
    accentColor: "#d25b2c",
  }),
];
